import FormControl from '@mui/material/FormControl';
import React, { useState } from "react";


const Signin: React.FC = () => {


    const [formData, setformData] = useState()
    return (
        <div>
            <FormControl defaultValue="" required>
                {/* <Label>Name</Label>
                <StyledInput placeholder="Write your name here" />
                <HelperText /> */}
            </FormControl>
        </div>
    )
}

export default Signin